export const ScatteredThunderStormsNightIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="47" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M3.333 40.402c0 6.618 4.278 12.425 10.518 14.543a1.55 1.55 0 00.996-2.934c-4.998-1.696-8.415-6.335-8.415-11.609 0-6.518 5.189-11.9 11.793-12.26a1.55 1.55 0 001.457-1.384c.79-7.535 7.274-13.326 15.05-13.326 6.416 0 12.066 3.96 14.223 9.782a1.55 1.55 0 002.906-1.077c-2.607-7.034-9.412-11.804-17.128-11.804-8.92 0-16.442 6.347-17.954 14.837-7.62 1.036-13.445 7.483-13.445 15.232zm68.49-1.768a8.667 8.667 0 011.745 5.225c0 4.867-4.017 8.822-8.986 8.822H34.05a1.55 1.55 0 000 3.098h30.533c6.669 0 12.085-5.331 12.085-11.92 0-2.586-.839-5.05-2.365-7.085a1.55 1.55 0 00-2.479 1.86z"
                        fill="#717277"
                    />
                    <path
                        d="M66.693 10.404c1.532.158 1.921 2.21.554 2.917a8.709 8.709 0 003.997 16.449 8.68 8.68 0 003.201-.607c1.432-.566 2.724 1.077 1.836 2.335a13.41 13.41 0 01-10.975 5.69c-7.416 0-13.428-6.012-13.428-13.428 0-7.415 6.012-13.427 13.428-13.427.465 0 .928.024 1.387.071zM54.977 23.761c0 5.704 4.624 10.328 10.329 10.328 1.769 0 3.463-.447 4.951-1.261-6.059-.502-10.82-5.579-10.82-11.767 0-2.58.835-5.012 2.292-6.993-3.942 1.455-6.752 5.246-6.752 9.693z"
                        fill="#717277"
                    />
                    <path
                        d="M43.65 64.275a1.55 1.55 0 00-2.19-2.191l-5.113 5.112a1.55 1.55 0 002.191 2.191l5.113-5.112zM64.308 64.275a1.55 1.55 0 00-2.19-2.191l-5.113 5.112a1.55 1.55 0 102.191 2.191l5.112-5.112z"
                        fill="#9ADAFF"
                    />
                    <path
                        d="M34.832 47.34c1.352-.004 2.06 1.604 1.144 2.599L18.558 68.85c-1.216 1.32-3.329-.14-2.524-1.744l5.964-11.896H14.18c-1.353 0-2.056-1.614-1.134-2.605l17.597-18.912c1.212-1.303 3.305.132 2.528 1.732l-5.8 11.937 7.462-.023zm-3.539 3.11l-6.398.02a1.55 1.55 0 01-1.398-2.227l2.36-4.858-8.12 8.727h6.771a1.55 1.55 0 011.385 2.244l-2.154 4.296 7.554-8.203z"
                        fill="#FDD36F"
                    />
                </g>
            </g>
        </g>
    </svg>
);
